import React from "react";

export const NominatorsContext = React.createContext(null)
